import { Form, FormikState, useFormikContext } from 'formik';

import { Button } from '../../../cdl/Button/Button';
import { Callout } from '../../../cdl/Callout/Callout';
import { DrawerContentLayout } from '../../../cdl/Drawer/DrawerContentLayout';
import { FormikInput } from '../../../cdl/Input/FormikInput';
import { FormikDebug } from '../../../common/form-elements/formik/FormikDebug';
import { Label } from '../../../common/form-elements/Label/Label';
import { translate } from '../../../common/helpers/translate.helper';
import { IconInfoCircle } from '../../../common/icons/cdl/InfoCircle';
import { FormikTagListInput } from '../../../common/TagListInput/FormikTagListInput';
import { FormikPortState } from '../FormikPortState';

import { FormikCountrySelect } from './FormikCountrySelect';
import { FormikTimeZoneSelect } from './FormikTimeZoneSelect';

type FormikPortFormProps = FormikState<FormikPortState> & {
    error: string | null;
};

export const FormikPortForm = (props: FormikPortFormProps) => {
    const formikState = useFormikContext<FormikPortState>();

    return (
        <Form style={{ height: '100%', minHeight: 0 }}>
            <DrawerContentLayout
                isBusy={formikState.isSubmitting}
                hasUnsavedChanges={formikState.dirty}
                primaryAction={
                    <Button
                        type="submit"
                        emphasis="high"
                        isLoading={formikState.isSubmitting}
                        disabled={!formikState.dirty}
                    >
                        {formikState.values.id ? translate('port.updatePort') : translate('port.createPort')}
                    </Button>
                }
            >
                <FormikInput label={translate('port.name')} name="name" />
                <FormikInput label={translate('port.locode')} name="locCode" />
                <FormikInput label={translate('port.latitudeOptionalLabel')} name="latitude" markAsOptional />
                <FormikInput label={translate('port.longitudeOptionalLabel')} name="longitude" markAsOptional />
                <FormikTimeZoneSelect label={translate('port.timeZone')} name="timeZoneId" />
                <Label label={translate('port.country')}>
                    <FormikCountrySelect name="countryId" />
                </Label>

                <FormikTagListInput name="aliases" label={translate('port.aliasesOptionalLabel')} markAsOptional />

                <FormikTagListInput
                    name="locCodeAliases"
                    label={translate('port.locCodeAliasesOptionalLabel')}
                    markAsOptional
                />

                {props.error ? <Callout variant="negative" description={props.error} Icon={IconInfoCircle} /> : null}

                <FormikDebug />
            </DrawerContentLayout>
        </Form>
    );
};
